// Academic Deliverables variant 1002 — "Placement Success" (IIT KGP LP)
// Two-band section ported from the IIT KGP landing-page PlacementLP organism:
// a stats band (title + sub-title + static salary-package rows from metadata)
// followed by a white hiring-partners band (heading + sub-title + "Get Started"
// lead CTA + desktop/mobile partner-logo strip).

export const ACADEMIC_DELIVERABLES_1002_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_salary_package: "₹12 LPA",
    meta_package_description: "Average package",
    meta_priority: 1,
    meta_status: true,
  },

  // Seed rows used by the admin preview when no metadata has been saved yet,
  // so the stats band is visible while editing.
  SEED_METADATA: [
    {
      id: "1",
      meta_salary_package: "₹24 LPA",
      meta_package_description: "Highest package",
      meta_priority: 1,
      meta_status: true,
    },
    {
      id: "2",
      meta_salary_package: "₹12 LPA",
      meta_package_description: "Average package",
      meta_priority: 2,
      meta_status: true,
    },
    {
      id: "3",
      meta_salary_package: "500+",
      meta_package_description: "Hiring partners",
      meta_priority: 3,
      meta_status: true,
    },
  ],

  ACADEMIC_DELIVERABLES_1002_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "Placement {Success}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Wrap the highlighted part in { } e.g. Placement {Success}",
      required: false,
      defaultValue: "Placement {Success}",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_title",
      label: "Sub Title",
      value:
        "Our learners are placed at top companies with industry-leading packages.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Sub Title",
      required: false,
      defaultValue:
        "Our learners are placed at top companies with industry-leading packages.",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "recruiters_title",
      label: "Hiring Partners Heading",
      value: "Our learners work at {top companies}",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "Wrap the highlighted part in { } e.g. Our learners work at {top companies}",
      required: false,
      defaultValue: "Our learners work at {top companies}",
    },
    {
      fieldName: "recruiters_sub_title",
      label: "Hiring Partners Sub Title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Hiring Partners Sub Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_text",
      label: "CTA Button Text",
      value: "Get Started",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Button Text",
      required: false,
      defaultValue: "Get Started",
    },
    {
      fieldName: "button_text_color",
      label: "CTA Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_background_color",
      label: "CTA Button Background Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave empty for theme primary color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "desktop_bg_image",
      label: "Hiring Partners Image (Desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Hiring Partners Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Hiring Partners Image (Mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Hiring Partners Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Hiring Partners Image Alt Text",
      value: "Hiring Partner Companies",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
      required: false,
      defaultValue: "Hiring Partner Companies",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Salary Package",
      fieldName: "meta_salary_package",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. ₹12 LPA",
      required: true,
    },
    {
      header: "Package Description",
      fieldName: "meta_package_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Average package",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ],
};
